import { FC, ReactNode } from 'react';

import { useTranscriptContext } from '../../store/transcript/utils/useTranscriptContext';
import {
  MessageCustomizationProps,
  TranscriptMessages,
} from './TranscriptMessages';
import { TranscriptWrapper } from './TranscriptWrapper.styled';
import { useStartChat } from './utils/useStartChat';


export type TranscriptProps = MessageCustomizationProps & {
  loadingMessage?: ReactNode;
  transcriptFooter?: ReactNode;
  assistantName?: string;
  avatarUrl?: string;
};

export const Transcript: FC<TranscriptProps> = (props) => {
  useStartChat();

  const { state } = useTranscriptContext();

  const { isAwaitingServerMessage, messages, initialMessage, loadFailed } =
    state;

  return (
    <TranscriptWrapper>
      <TranscriptMessages
        failed={loadFailed}
        isLoading={isAwaitingServerMessage}
        messages={messages}
        initialMessage={initialMessage}
        {...props}
      />
      {props.transcriptFooter && props.transcriptFooter}
    </TranscriptWrapper>
  );
};
